/* =========================================================================
 * Kkumi · Cart add-from-link (cart page)
 * -------------------------------------------------------------------------
 * Kkumi Oracle's "Your usual" email links to /cart?kk_add=<variant>:<qty>,…
 * (docs/kkumi-oracle.md → Guides: help that costs nothing). Shopify's own
 * cart links can add only one item, or replace the whole cart; this adds every
 * item to the customer's existing cart through KKCartCodes.addItems, then
 * reloads the cart without the parameter so a refresh can't add them twice.
 * If the whole batch is refused (one item sold out), each item is tried on its
 * own, so the rest still land. No visible copy: the cart itself is the result.
 *
 * Its "Left in their cart" email links to /cart?kk_fill=<variant>:<qty>,… :
 * the same, but only what's missing goes in (the cart read first), so a cart
 * still intact on this device isn't doubled and one on another device is
 * rebuilt.
 * ========================================================================= */
(function () {
  'use strict';
  var u;
  try { u = new URL(window.location.href); } catch (e) { return; }
  var fill = !u.searchParams.get('kk_add') && !!u.searchParams.get('kk_fill');
  var raw = u.searchParams.get('kk_add') || u.searchParams.get('kk_fill');
  if (!raw) return;
  u.searchParams.delete('kk_add');
  u.searchParams.delete('kk_fill');
  // The parameter goes first: a reload or a back-button can never add the items again.
  try { window.history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) {}
  var items = String(raw).split(',').slice(0, 12).map(function (part) {
    var m = /^(\d{1,20}):(\d{1,2})$/.exec(part.trim());
    return m ? { id: Number(m[1]), quantity: Math.max(1, Math.min(10, Number(m[2]))) } : null;
  }).filter(Boolean);
  var codes = window.KKCartCodes;
  if (!items.length || !codes || !codes.addItems) return;
  var done = function () { window.location.replace(u.pathname + u.search + u.hash); };
  var addAll = function (list) {
    if (!list.length) return done();
    codes.addItems(list).then(done, function () {
      var one = function (i) {
        if (i >= list.length) return Promise.resolve();
        return codes.addItems([list[i]]).catch(function () {}).then(function () { return one(i + 1); });
      };
      one(0).then(done);
    });
  };
  if (!fill) return addAll(items);
  // kk_fill: top each line up to its quantity; a cart that can't be read gets everything (as kk_add).
  fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      var have = {};
      ((cart && cart.items) || []).forEach(function (i) { have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
      addAll(items.map(function (i) { return { id: i.id, quantity: i.quantity - (have[i.id] || 0) }; }).filter(function (i) { return i.quantity > 0; }));
    }, function () { addAll(items); });
})();
